import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { getRequiredErrorMessage } from '../../utils/common.utils';
import TextInput from '../form-controls/TextInput';
import { FormInput } from './FundWallet';
import { USER } from '../../interfaces/auth.interface';
import Select from '../form-controls/Select';

interface Props  {
  user: USER;
  formValues: FormInput;
  setFormValues: React.Dispatch<React.SetStateAction<FormInput>>;
  setFormStep: React.Dispatch<
    React.SetStateAction<'amount' | 'payment_method'>
  >;
}

const schema = yup.object().shape({
  Amount: yup
    .number()
    .min(1, 'Value must be a number greater than 1')
    .required(getRequiredErrorMessage('Amount'))
    .typeError('Amount must be a number'),
    CardCode: yup
    .object()
    .typeError('Select card type'),
});

interface Inputs {
  Amount: number;
  CardType : number;
  CardCode : number;
}

const countryList  = [
  { code: 1, name: 'Naira'},
  { code: 76, name: 'Cedis'},
  { code: 207, name: 'Dollar'},
  { code: 62, name: 'Pound'},
];

const AmountForm: React.FC<Props> = ({
  setFormStep,
  formValues,
  setFormValues,
  user,
  
}) => {
  const { handleSubmit, control, watch, errors } = useForm<Inputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      Amount: formValues?.Amount,
      CardCode : 0
    },
  });
const cardcode : any = watch('CardCode');
const [code, setCode] = React.useState(0);

React.useEffect(() => {
  setCode(cardcode.code)
}, [setCode])

const onSubmit = (data: Inputs) => {
    setFormStep('payment_method');
    setFormValues({
      ...formValues,
      Amount: data.Amount,
      CardCode: cardcode.code
    });
  };
  
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="w-full max-w-md mx-auto text-center mb-10">
        <p className="text-xl font-semibold mb-5">
          Hi {user?.FirstName} {user?.LastName}, please note we will direct you
          to our payment platform to fund your wallet
        </p>
        <p className="font-medium">
          Please kindly enter the amount to fund this wallet
        </p>
      </div>
      <div className="w-full max-w-xs mx-auto">
     
        { user?.Country?.CountryId === 207 &&
            <div className="mb-8 text-sm  text-gray-500 font-medium"> 
            <Controller
                          name="CardCode"
                          control={control}
                          defaultValue=""
                          render={({ name, value, onChange }) => (
                            <Select
                            name={name}
                            value={countryList.find(c => c.name === value)}
                            id={name}
                            wrapperClassName="w-full"
                            valueKey="name"
                            labelKey="name"
                            error={errors['CardCode']}
                            labelClassName="mb-2 flex"
                            placeholder="Select Card Type"
                            customChange={onChange}
                            className="rounded-md"
                            options={countryList}
                        />
                          )}
                          
                        />
                </div>
    
         }
           { user?.Country?.CountryId === 62 &&
            <div className="mb-8 text-sm text-gray-500 font-medium"> 
            <Controller
                          name="CardCode"
                          control={control}
                          defaultValue=""
                          render={({ name, value, onChange }) => (
                            <Select
                            name={name}
                            value={countryList.find(c => c.name === value)}
                            id={name}
                            wrapperClassName="w-full"
                            valueKey="name"
                            labelKey="name"
                            error={errors['CardCode']}
                            labelClassName="mb-2 flex"
                            placeholder="Select Card Type"
                            customChange={onChange}
                            className="rounded-md"
                            options={countryList}
                        />
                          )}
                          
                        />
                </div>
    
         }

<div className="mb-8 w-full">
          <Controller
            name="Amount"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                id={name}
                type="number"
                appendStyles
                className="w-full border p-4 border-gray-300 rounded-lg"
                wrapperClassName="w-full"
                error={errors['Amount']}
                placeholder="Enter amount"
                customChange={onChange}
              />
            )}
          />
        </div>
              <button
              className="w-full bg-secondary font-bold text-sm rounded text-white py-5"
              type="submit"
            >
              Fund Wallet
            </button>

  
      </div>
    </form>
  );
};

export default AmountForm;
